module.exports = __webpack_public_path__ + "static/media/noimage.84756cd3.png";